



































import Vue from 'vue';
import MassSendRecordItem from './MassSendRecordItem.vue';
import massClient from '../../apis';
import scheduleClient from '../../../rule/apis';
import customerClient from '../../../customer/apis';
import { TaskType } from '../../../common/models/TaskType';
import WxTemplate from '@/rule/models/WxTemplate';
import massVuex from '../../vuex/common';
import settingsClient from '../../../settings/apis';

const massTypes = [TaskType.MassSend, TaskType.Broadcast, TaskType.TemplateSend, TaskType.WxSubTpl]

export default Vue.extend({
  mixins: [massVuex],
  components: {
    MassSendRecordItem,
  },
  data() {
    return {
      pollHandler: null,
      TaskType,
      massTypes,
      type: massTypes,
      page: 1,
      size: 10,
      tasks: [],
      total: 0,
      loaded: false,
      remarkLoaded: false,
      templateLoaded: false,
      selectedType: 0,
      tplData: [],
      massFailures: {},
    };
  },
  computed: {
    show(): boolean {
      return this.tasks.length > 0 && this.loaded && this.remarkLoaded && this.templateLoaded;
    },
  },
  methods: {
    changePage(page: number) {
      if (this.page !== page) {
        this.page = page;
        this.getTasks();
      }
    },
    setType(taskType: number) {
      switch (taskType) {
        case TaskType.MassSend:
          this.type = [TaskType.MassSend];
          this.selectedType = TaskType.MassSend;
          break;
        case TaskType.Broadcast:
          this.type = [TaskType.Broadcast];
          this.selectedType = TaskType.Broadcast;
          break;
        case TaskType.TemplateSend:
          this.type = [TaskType.TemplateSend];
          this.selectedType = TaskType.TemplateSend;
          break;
        case TaskType.WxSubTpl:
          this.type = [TaskType.WxSubTpl]
          this.selectedType = TaskType.WxSubTpl
          break
        default:
          this.selectedType = 0;
          this.type = massTypes;
      }
      this.getTasks();
    },
    getRemarks() {
      this.loadedRemark = false;
      customerClient.getRemarks({
        page: 1,
        size: 1000,
      }).success((r: any) => {
        this.$store.commit('UPDATE_REMARKS', r.remarks);
        this.remarkLoaded = true;
      });
    },
    getTasks() {
      massClient.getTaskByTypes({
        page: this.page,
        size: this.size,
        tpes: this.type}
      ).success((r: any) => {
        this.tasks = r.tasks;
        this.tplData = r.tplData;
        this.massFailures = r.massFailures || {};
        this.total = r.total;
        this.loaded = true;
      });
    },
    loadTemplates() {
      scheduleClient.getTemplates().success((r: any) => {
        const wxTemplates: WxTemplate[] = [];
        const templateList = r.templateList;
        for (const tpl of templateList) {
          wxTemplates.push(new WxTemplate(tpl));
        }
        this.$store.commit('UPDATE_WX_TEMPLATES', wxTemplates);
        this.templateLoaded = true;
      });
    },
    loadTopics() {
      settingsClient.getTopics().success((r: any) => {
        this.$store.commit('SET_TOPICS', r.topics);
      });
    },
  },
  mounted() {
    this.loadTopics();
    this.getTasks();
    this.getRemarks();
    this.loadTemplates();
    this.pollHandler = setInterval(() => {
      this.getTasks();
    }, 5000);
  },
  beforeDestroy() {
    if(this.pollHandler) {
      clearInterval(this.pollHandler)
    }
  },
});
